var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkerHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 450",
    style: {
      enableBackground: "new 0 0 450 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A88A5"
    },
    d: "M262.988,393.39c-0.699,0-1.325-0.492-1.469-1.204c-0.163-0.813,0.362-1.602,1.175-1.767 l116.01-23.35c0.808-0.157,1.602,0.362,1.767,1.175c0.163,0.813-0.362,1.603-1.175,1.767l-116.01,23.35 C263.186,393.38,263.087,393.39,262.988,393.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A88A5"
    },
    d: "M296.389,257.59c-0.806,0-1.472-0.639-1.498-1.45c-0.027-0.828,0.621-1.521,1.449-1.549l82.61-2.75 c0.804-0.07,1.521,0.621,1.549,1.449c0.027,0.828-0.621,1.521-1.449,1.549l-82.61,2.75 C296.423,257.59,296.405,257.59,296.389,257.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A88A5"
    },
    d: "M263.908,157.641c-0.704,0-1.333-0.499-1.471-1.217c-0.157-0.813,0.376-1.6,1.19-1.756l95.58-18.39 c0.806-0.154,1.6,0.375,1.756,1.19c0.157,0.814-0.376,1.6-1.19,1.756l-95.58,18.39 C264.098,157.631,264.003,157.641,263.908,157.641z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A88A5"
    },
    d: "M185.061,161.57c-0.111,0-0.224-0.013-0.337-0.039l-94.55-21.73 c-0.808-0.186-1.312-0.991-1.126-1.798c0.186-0.807,0.989-1.312,1.798-1.126l94.55,21.73c0.808,0.186,1.311,0.991,1.126,1.798 C186.362,161.1,185.745,161.57,185.061,161.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A88A5"
    },
    d: "M71.511,369.84c-0.44,0-0.877-0.193-1.173-0.563c-0.517-0.647-0.412-1.592,0.236-2.108l80.38-64.21 c0.647-0.516,1.591-0.41,2.108,0.235c0.517,0.647,0.412,1.592-0.236,2.108l-80.38,64.21 C72.169,369.732,71.839,369.84,71.511,369.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A88A5"
    },
    d: "M71.511,258.94c-0.524,0-1.033-0.274-1.309-0.764c-0.406-0.723-0.15-1.637,0.571-2.043 l126.614-71.279c0.722-0.406,1.636-0.15,2.043,0.571c0.406,0.722,0.15,1.637-0.571,2.043L72.246,258.747 C72.013,258.879,71.76,258.94,71.511,258.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A88A5"
    },
    d: "M224.92,117.83h-0.002c-0.829-0.001-1.499-0.674-1.498-1.502l0.08-56.22 c0.001-0.828,0.672-1.498,1.5-1.498h0.001c0.829,0.001,1.5,0.674,1.499,1.502l-0.08,56.22 C226.419,117.16,225.748,117.83,224.92,117.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0A88A5"
    },
    cx: 225,
    cy: 60.113,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M225,23.363c-20.296,0-36.75,16.453-36.75,36.749c0,20.297,16.454,36.75,36.75,36.75 s36.75-16.453,36.75-36.75C261.75,39.816,245.296,23.363,225,23.363z M248.152,68.525c-1.095,0-8.513,2.355-23.147,2.355 c-14.639,0-22.06-2.355-23.152-2.355c-4.744,0-7.085-0.877-1.996-5.109c1.398-6.42,4.493-11.573,8.918-15.099 c-0.473-0.879-0.174-1.977,0.696-2.482l3.216-1.854c0.887-0.512,2.024-0.211,2.534,0.679l0.025,0.044 c1.884-0.69,3.9-1.172,6.042-1.428v-0.241c0-1.025,0.831-1.855,1.855-1.855H225h0.005h1.856c1.023,0,1.854,0.83,1.854,1.855v0.241 c2.143,0.256,4.161,0.737,6.042,1.428l0.027-0.044c0.511-0.89,1.647-1.19,2.533-0.679l3.216,1.854 c0.871,0.506,1.17,1.604,0.697,2.482c4.423,3.525,7.518,8.679,8.917,15.099C255.234,67.648,252.895,68.525,248.152,68.525z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0A88A5"
    },
    cx: 71.508,
    cy: 253.341,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M71.508,216.592c-20.296,0-36.75,16.453-36.75,36.748c0,20.296,16.454,36.75,36.75,36.75 s36.75-16.454,36.75-36.75C108.258,233.045,91.804,216.592,71.508,216.592z M45.838,245.025c0-2.935,0.707-4.623,2.161-5.164 c3.234-1.205,8.543,4.319,14.23,10.855c-0.368,0.407-0.728,0.837-1.073,1.288c-3.435-3.962-10.144-11.489-12.579-10.592 c-0.698,0.261-1.083,1.543-1.083,3.613c0,7.895,5.534,14.541,10.441,18.486c0.176,0.934,0.443,1.83,0.813,2.673 C53.01,262.172,45.838,254.311,45.838,245.025z M71.509,272.286c-6.712,0-12.151-4.464-12.151-11.176 c0-4.118,2.744-8.41,5.989-11.114c2.043-1.702,2.917-4.142,6.162-4.142c3.34,0,4.122,2.439,6.168,4.144 c3.242,2.703,5.984,6.996,5.984,11.111C83.661,267.822,78.221,272.286,71.509,272.286z M84.271,266.183 c0.369-0.842,0.637-1.738,0.813-2.672c4.906-3.945,10.44-10.591,10.44-18.485c0-2.07-0.385-3.353-1.082-3.612 c-2.432-0.906-9.144,6.626-12.58,10.59c-0.346-0.452-0.706-0.882-1.072-1.289c5.686-6.534,10.988-12.06,14.229-10.853 c1.454,0.541,2.161,2.23,2.161,5.164C97.18,254.31,90.01,262.171,84.271,266.183z M77.305,253.308 c-0.828,0-2.484-3.312-5.796-3.312c-3.313,0-4.969,3.312-5.798,3.312c-0.533,0-0.826,0.371-0.826,0.827 c0,0.46,0.369,0.829,0.826,0.829c0.829,0,4.141-3.313,5.798-3.313c1.656,0,4.968,3.313,5.796,3.313 c0.508,0,0.827-0.369,0.827-0.829C78.132,253.679,77.763,253.308,77.305,253.308z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A88A5"
    },
    d: "M401.492,138.34c0,23.196-18.806,42.001-42,42.001c-23.196,0-42-18.805-42-42.001 c0-23.196,18.804-42,42-42C382.686,96.34,401.492,115.144,401.492,138.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M359.49,101.591c-20.293,0-36.748,16.454-36.748,36.749c0,20.297,16.455,36.75,36.748,36.75 c20.298,0,36.752-16.453,36.752-36.75C396.242,118.045,379.788,101.591,359.49,101.591z M385.164,138.34 c0,0.918-0.743,1.656-1.657,1.656h-0.943c-0.818,6.526-6.391,11.594-13.136,11.594c-2.998,0-4.417-0.614-6.624-1.656 c-0.554-0.26-1.654-1.655-3.31-1.579c-1.657-0.076-2.761,1.319-3.314,1.579c-2.204,1.042-3.626,1.656-6.624,1.656 c-6.745,0-12.316-5.067-13.135-11.594h-0.941c-0.917,0-1.659-0.738-1.659-1.656v-6.623c0-0.916,0.742-1.656,1.659-1.656h0.826 v-1.656c0-1.828,1.485-3.313,3.314-3.313h39.746c1.829,0,3.312,1.483,3.312,3.313v1.656h0.829c0.914,0,1.657,0.74,1.657,1.656 V138.34z M369.428,128.818h-19.872c-8.01,0-9.522,1.513-9.522,9.521c0,2.541,0.988,4.931,2.791,6.733 c1.801,1.799,4.189,2.791,6.73,2.791c1.836,0,3.49-0.855,5.095-1.689c1.544-0.797,3.138-1.624,4.844-1.624 c1.704,0,3.3,0.827,4.84,1.623c1.603,0.834,3.261,1.689,5.094,1.689c5.252,0,9.524-4.273,9.524-9.525 c0-4.346-0.486-6.527-1.739-7.777C375.956,129.308,373.777,128.818,369.428,128.818z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0A88A5"
    },
    cx: 90.508,
    cy: 138.341,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M90.507,101.591c-20.296,0-36.749,16.453-36.749,36.749c0,20.297,16.453,36.75,36.749,36.75 c20.298,0,36.751-16.453,36.751-36.75C127.258,118.044,110.805,101.591,90.507,101.591z M110.882,156.388 c-0.06,1.129-0.979,1.99-2.045,1.927c-1.069-0.067-1.885-1.035-1.824-2.163l1-18.411c0.06-1.128,0.976-1.993,2.046-1.925 c1.064,0.064,1.883,1.03,1.822,2.162c0.058,0.003,0.114,0.018,0.17,0.024c-0.667-5.026-2.869-9.538-6.092-12.982 c-0.839,0.06-2.354-0.664-3.85-1.918c-0.711-0.596-1.319-1.228-1.773-1.818c-0.878,0.126-2.306-0.148-3.828-0.813 c-1.106-0.483-2.046-1.076-2.687-1.65c-0.811,0.326-1.986,0.536-3.314,0.536c-1.327,0-2.501-0.21-3.313-0.536 c-0.641,0.574-1.581,1.167-2.689,1.65c-1.521,0.665-2.95,0.939-3.824,0.813c-0.456,0.591-1.061,1.223-1.775,1.818 c-1.496,1.256-3.013,1.978-3.852,1.917c-3.223,3.444-5.425,7.956-6.092,12.982c0.058-0.005,0.114-0.02,0.173-0.024 c-0.061-1.132,0.755-2.099,1.824-2.162c1.068-0.068,1.983,0.797,2.043,1.925l1.002,18.411c0.061,1.128-0.757,2.096-1.824,2.163 c-1.069,0.063-1.985-0.798-2.045-1.927c-3.205,0.192-6.024-3.77-6.302-8.852c-0.13-2.388,0.33-4.591,1.181-6.284v-0.031 c0-14.854,11.436-26.94,25.493-26.94c14.059,0,25.495,12.086,25.495,26.94v0.034c0.849,1.693,1.31,3.895,1.182,6.281 C116.905,152.617,114.086,156.578,110.882,156.388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0A88A5"
    },
    cx: 378.492,
    cy: 368.341,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M378.492,331.591c-20.297,0-36.75,16.453-36.75,36.751c0,20.297,16.453,36.749,36.75,36.749 c20.296,0,36.75-16.452,36.75-36.749C415.242,348.044,398.788,331.591,378.492,331.591z M372.54,344.537h19.836l-0.003,2.313 h-14.876v4.301h-4.719l-0.119-1.33c-0.067-0.723-0.119-1.91-0.119-2.638V344.537z M363.065,388.175h-3.088 c-0.726,0-1.471-0.148-1.653-0.329c-0.181-0.182-0.33-0.776-0.33-1.324c0-0.54,0.15-0.989,0.33-0.989c0.183,0,0.183-0.297,0-0.662 c-0.181-0.364-0.328-1.257-0.328-1.982c0-0.728,0.298-1.621,0.658-1.983c0.365-0.364,1.227-0.849,1.918-1.08l1.458-0.484 c0.688-0.229,1.842-0.519,2.558-0.637l5.325-0.888c0.718-0.118,1.725-0.637,2.239-1.153l2.099-2.097 c0.513-0.515,0.861-1.526,0.768-2.249l-0.992-7.952c-0.093-0.722-0.22-1.904-0.283-2.63l-0.785-8.602h4.605 c0.019,0.294,0.037,0.574,0.06,0.81l0.136,1.504l0.947,10.408c0.067,0.739,0.197,1.945,0.289,2.681l0.995,7.959 c0.026,0.214-0.145,0.717-0.3,0.87l-2.096,2.096c-0.271,0.271-0.962,0.627-1.339,0.691l-5.328,0.887 c-0.783,0.129-2.014,0.434-2.81,0.695l-1.46,0.487c-0.809,0.271-1.946,0.865-2.561,1.48c-0.786,0.788-1.145,2.186-1.145,3.152 C362.953,387.241,362.992,387.711,363.065,388.175z M397.783,365.702c-0.065,0.723-0.217,1.902-0.336,2.622l-0.888,5.324 c-0.119,0.716-0.218,1.898-0.218,2.629c0,0.723,0.189,1.884,0.418,2.572l0.486,1.459c0.231,0.689,0.418,1.851,0.418,2.579v2.645 c0,0.728,0,1.618,0,1.982c0,0.368-0.15,0.96-0.33,1.322c-0.183,0.367-0.183,0.66,0,0.66c0.181,0,0.33,0.449,0.33,0.994 c0,0.547-0.071,1.138-0.164,1.321c-0.092,0.183-0.763,0.33-1.488,0.33h-6.281c-0.728,0-1.323-0.299-1.323-0.661 c0-0.361-0.595-0.66-1.32-0.66h-1.323c-0.726,0-1.62,0.299-1.983,0.66c-0.362,0.365-1.257,0.661-1.984,0.661h-15.207 c-0.726,0-1.468-0.148-1.65-0.33c-0.183-0.184-0.333-0.774-0.333-1.321c0-0.545,0.15-0.994,0.333-0.994c0.183,0,0.183-0.293,0-0.66 c-0.183-0.362-0.333-1.258-0.333-1.983c0-0.73,0.298-1.618,0.663-1.983c0.362-0.364,1.227-0.851,1.915-1.081l1.458-0.487 c0.691-0.226,1.842-0.514,2.56-0.632l5.326-0.888c0.716-0.121,1.725-0.638,2.239-1.153l2.096-2.095 c0.515-0.516,0.861-1.527,0.771-2.248l-0.997-7.956c-0.09-0.722-0.215-1.905-0.283-2.628l-0.781-8.6h18.994L397.783,365.702z  M398.987,351.151c0,0.727-0.056,1.914-0.119,2.639l-0.119,1.327h-19.354l-0.123-1.327c-0.066-0.725-0.121-1.912-0.121-2.639 l0.002-2.646h19.835V351.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0A88A5"
    },
    cx: 71.508,
    cy: 368.341,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M71.508,331.591c-20.296,0-36.75,16.453-36.75,36.749c0,20.298,16.454,36.752,36.75,36.752 c20.297,0,36.75-16.454,36.75-36.752C108.258,348.044,91.805,331.591,71.508,331.591z M56.538,375.149l-10.372-6.053 c-1.397-0.814-1.869-2.607-1.054-4.004c0.816-1.396,2.608-1.868,4.003-1.051l4.172,2.435l-4.381-11.643 c-0.494-1.313,0.167-2.774,1.479-3.269c1.307-0.491,2.764,0.168,3.263,1.471l-0.887-2.357c0-0.001-0.001-0.004-0.003-0.007 c-0.491-1.309,0.171-2.773,1.481-3.266c1.312-0.495,2.773,0.169,3.268,1.477v0.002l0.444,1.183 c-0.488-1.312,0.173-2.769,1.483-3.264c1.313-0.492,2.776,0.171,3.27,1.481l0.001-0.001l1.338,3.558 c-0.491-1.311,0.172-2.771,1.479-3.263c1.313-0.494,2.773,0.168,3.269,1.482l0.999,2.656c-0.961,0.372-1.771,1.035-2.299,1.939 c-0.616,1.058-0.784,2.291-0.472,3.473l2.881,10.965l-5.321,9.38c-1.044,0.09-1.973,0.739-2.416,1.709 c-0.155,0.347-0.233,0.709-0.25,1.067l-3.344,1.259L56.538,375.149z M60.675,389.705c-0.656,0.25-1.388-0.082-1.634-0.737 c-0.248-0.657,0.084-1.389,0.739-1.638l0.107-0.037l-0.789-2.859l3.414-1.285c0.282,0.374,0.649,0.694,1.106,0.901l5.483,2.484 L60.675,389.705z M86.146,389.657c0.64,0.286,0.92,1.041,0.632,1.678c-0.287,0.639-1.039,0.922-1.677,0.635l-20.798-9.427 c-0.636-0.289-0.919-1.038-0.632-1.678c0.291-0.638,1.043-0.923,1.681-0.634l0.104,0.049l1.464-2.577l20.095,9.103l-0.974,2.802 L86.146,389.657z M90.225,377.58h0.002l-2.556,7.344l-19.768-8.955l3.768-6.644l-3.052-11.615 c-0.413-1.563,0.522-3.164,2.084-3.572c1.563-0.414,3.165,0.522,3.575,2.085l1.228,4.673l5.134-11.332 c0.579-1.275,2.081-1.843,3.357-1.264c1.272,0.576,1.837,2.072,1.269,3.347l1.039-2.294c0.001-0.003,0.001-0.005,0.001-0.006 c0.578-1.275,2.084-1.841,3.358-1.263c1.278,0.577,1.842,2.079,1.265,3.355l0,0l-0.52,1.15c0.58-1.271,2.079-1.834,3.354-1.256 c1.275,0.576,1.842,2.08,1.264,3.355h0.003l-1.572,3.463c0.581-1.273,2.083-1.838,3.357-1.263c1.275,0.581,1.84,2.083,1.262,3.36 L90.225,377.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0A88A5"
    },
    cx: 378.492,
    cy: 253.34,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M378.489,216.592c-20.294,0-36.747,16.453-36.747,36.75c0,20.294,16.453,36.748,36.747,36.748 c20.299,0,36.753-16.454,36.753-36.748C415.242,233.045,398.788,216.592,378.489,216.592z M356.159,253.942 c4.354-1.98,7.132-7.075,6.47-12.545l-1.214-11.701l3.915-0.55l5.543,30.106h-14.714V253.942z M378.489,274.032 c0,2.448-1.764,4.434-3.939,4.434l-14.449-1.477c-2.178,0-3.941-1.985-3.941-4.434v-2.96h22.33V274.032z M378.489,266.641h-22.33 v-4.434h22.33V266.641z M378.489,259.252h-4.52l-5.623-30.532l3.578-0.504l6.564,16.256V259.252z M385.059,228.216l3.578,0.504 l-5.625,30.532h-2.867v-15.1l-0.763-1.887L385.059,228.216z M400.82,272.556c0,2.448-1.762,4.434-3.939,4.434l-14.447,1.477 c-1.19,0-2.242-0.602-2.964-1.536c0.431-0.863,0.675-1.85,0.675-2.897v-4.436h20.676V272.556z M400.82,266.641h-20.676v-4.434 h20.676V266.641z M400.82,259.252h-14.714l5.547-30.106l3.915,0.55l-1.216,11.701c-0.664,5.47,2.118,10.564,6.468,12.545V259.252z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 203.8467,
    cy: 57320.375,
    r: 130.5306,
    gradientTransform: "matrix(1 0 0 0.1284 0 -6943.1655)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0978,
    style: {
      stopColor: "#2D2D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2317,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3668,
    style: {
      stopColor: "#939393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5001,
    style: {
      stopColor: "#BABABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6312,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7596,
    style: {
      stopColor: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "url(#SVGID_1_)"
    },
    d: "M354.662,416.77c0,7.663-67.521,13.874-150.815,13.874 c-83.294,0-150.815-6.211-150.815-13.874c0-7.661,67.521-13.872,150.815-13.872C287.141,402.897,354.662,409.108,354.662,416.77z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000092437549222131536660000017026131133989651620_",
    cx: 226.4745,
    cy: 57320.375,
    r: 130.534,
    gradientTransform: "matrix(1.2256 0 0 0.1284 -51.4138 -6943.1655)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3316,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    style: {
      stopColor: "#0D0D0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3928,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4458,
    style: {
      stopColor: "#6D6D6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    style: {
      stopColor: "#949494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5598,
    style: {
      stopColor: "#B5B5B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6223,
    style: {
      stopColor: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7661,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8566,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000092437549222131536660000017026131133989651620_)"
    },
    d: "M411,416.77 c0,7.663-82.758,13.874-184.848,13.874c-102.087,0-184.845-6.211-184.845-13.874c0-7.661,82.759-13.872,184.845-13.872 C328.242,402.897,411,409.108,411,416.77z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#681E1E"
    },
    d: "M238.344,201.47c0,8.929-7.504,3.233-13.439,3.233c-5.938,0-13.438,5.696-13.438-3.233 s7.501-67.906,13.438-67.906C230.84,133.564,238.344,192.541,238.344,201.47z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M175.264,276.82h-13.089c0-38.215,20.357-66.879,28.095-71.325l6.52,11.349l0.128-0.08 C193.095,219.466,175.264,243.725,175.264,276.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05,
      fill: "#212121"
    },
    d: "M196.789,216.845l-6.52-11.349c-0.084,0.048-0.178,0.115-0.265,0.169l5.936,10.332 l0.128-0.08c-3.823,2.701-21.654,26.96-21.654,60.056h-12.225c-0.003,0.283-0.015,0.563-0.015,0.848h13.089 c0-33.096,17.831-57.354,21.653-60.055L196.789,216.845z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M158.729,289.866c-0.293,7.714,3.435,14.175,8.32,14.418c13.279,0.664,9.09-5.815,9.385-13.53 c0.294-7.715-3.432-14.174-8.319-14.419C159.86,275.921,159.262,275.891,158.729,289.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M173.16,287.237c2.959,4.471,6.541,7.066,8.004,5.791c1.461-1.272,0.246-5.933-2.711-10.406 c-2.956-4.475-6.538-7.072-8.003-5.798C168.987,278.1,170.199,282.759,173.16,287.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M177.392,269.275c0.252,3.582-1.395,10.685-1.395,10.685l-15.763,1.071 c0,0-1.847-10.213-0.666-13.227C162.253,268.923,174.109,270.438,177.392,269.275z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#212121"
    },
    d: "M178.453,282.622c-0.764-1.156-1.569-2.181-2.369-3.052 c0.333-1.516,1.524-7.207,1.308-10.295c-0.232,0.082-0.517,0.148-0.827,0.204c-0.047,3.186-1.03,7.886-1.329,9.243 c0.8,0.871,1.606,1.895,2.37,3.051c2.956,4.475,4.172,9.134,2.711,10.406c-0.943,0.822-2.77,0.021-4.739-1.84 c-0.132,7.522,3.654,13.747-9.376,13.097c-1.449-0.073-2.792-0.703-3.963-1.74c1.348,1.549,2.999,2.497,4.811,2.588 c13.029,0.651,9.244-5.574,9.376-13.097c1.97,1.86,3.796,2.662,4.738,1.841C182.625,291.756,181.41,287.096,178.453,282.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M287.631,276.82h-13.086c0-33.098-17.832-57.355-21.652-60.055l6.646-11.27 C267.275,209.94,287.631,238.602,287.631,276.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05,
      fill: "#212121"
    },
    d: "M259.539,205.496l-0.486,0.826c8.447,6.418,26.883,34.12,26.883,70.499h1.695 C287.631,238.602,267.275,209.94,259.539,205.496z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M291.082,289.866c0.293,7.714-3.434,14.175-8.32,14.418c-13.281,0.664-9.094-5.815-9.385-13.53 c-0.293-7.715,3.43-14.174,8.316-14.419C289.951,275.921,290.551,275.891,291.082,289.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M276.65,287.237c-2.959,4.471-6.543,7.066-8.004,5.791c-1.461-1.272-0.246-5.933,2.713-10.406 c2.953-4.475,6.539-7.072,8-5.798C280.82,278.1,279.609,282.759,276.65,287.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M272.42,269.275c-0.254,3.582,1.393,10.685,1.393,10.685l15.762,1.071 c0,0,1.85-10.213,0.668-13.227C287.557,268.923,275.699,270.438,272.42,269.275z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#212121"
    },
    d: "M291.082,289.866c-0.215-5.607-0.445-8.936-1.172-10.914 c0.469-3.145,1.178-8.988,0.332-11.147c-0.322,0.135-0.781,0.273-1.336,0.414c0.156,2.705-0.336,6.646-0.691,9.037 c0.725,1.979,0.957,5.307,1.17,10.913c0.293,7.715-3.434,14.176-8.32,14.419c-3.707,0.186-6.049-0.188-7.512-0.987 c0.98,1.915,3.451,2.972,9.209,2.684C287.648,304.041,291.375,297.58,291.082,289.866z M268.646,293.028 c0.641,0.558,1.693,0.353,2.918-0.411c1.162-0.83,2.188-1.438,2.082-2.657c-1.359,1.286-4.602,1.579-5.582,1.668 C268.127,292.241,268.309,292.733,268.646,293.028z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#184054"
    },
    points: "250.77,396.799 236.662,396.799 227.256,292.391 262.525,285.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#184054"
    },
    points: "199.038,396.799 213.145,396.799 222.554,292.391 187.282,285.863  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#184054"
    },
    points: "234.309,318.494 227.924,314.721 221.885,314.721 215.497,318.494 215.497,282.602  234.309,282.602  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#212121"
    },
    d: "M258.697,286.571l-11.32,106.835h-11.021l0.307,3.392h14.107l11.756-110.935 L258.697,286.571z M227.256,311.328h-8.764l-1.419,0.838l-7.321,81.24h-11.073l0.359,3.392h14.106l7.321-81.24l1.419-0.838h6.039 l1.418,0.838L227.256,311.328z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#153D51"
    },
    d: "M188.263,249.977c0-48.506,16.407-61.441,36.644-61.441c20.238,0,36.641,12.935,36.641,61.441 H188.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#153D51"
    },
    d: "M259.103,233.805c14.656,0,17.102-12.931,17.102-16.165c0-3.233-7.33-16.169-24.43-22.637 c-17.1-6.467-2.443,25.87-2.443,25.87L259.103,233.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#153D51"
    },
    d: "M190.705,233.805c-14.656,0-17.098-12.931-17.098-16.165c0-3.233,7.325-16.169,24.427-22.637 c17.099-6.467,2.442,25.87,2.442,25.87L190.705,233.805z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#153D51"
    },
    d: "M266.432,212.788c0,13.395-18.594,24.251-41.526,24.251c-22.935,0-41.528-10.856-41.528-24.251 c0-13.396,18.594-24.253,41.528-24.253C247.838,188.535,266.432,199.392,266.432,212.788z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F57F17"
    },
    d: "M261.564,245.089c-10.943-5.435-13.297-23.411-8.277-48.364c0.152-0.761,0.305-1.5,0.461-2.252 l-15.516-5.937l-13.327,35.95v62.92c0,4.959,3.159,8.987,7.054,8.987l25.865-2.997c3.895,0,7.057-4.025,7.057-8.989 l-2.463-37.684C262.254,245.816,262.703,245.652,261.564,245.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E26910"
    },
    d: "M262.418,246.723c-0.164-0.902,0.279-1.068-0.842-1.627l0.982,36.987 c0,4.965-3.162,8.99-7.057,8.99l-25.865,2.997c-1.104,0-2.135-0.352-3.064-0.928c1.295,1.97,3.213,3.25,5.387,3.25l25.865-2.997 c3.895,0,7.057-4.025,7.057-8.989L262.418,246.723z M256.453,240.909c-6.436-8.024-7.273-23.763-3.166-44.185 c0.152-0.761,0.305-1.5,0.461-2.252l-2.596-0.993c-0.063,0.307-0.125,0.611-0.189,0.922 C246.41,217.051,247.951,233.917,256.453,240.909z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#212121"
    },
    points: "263.301,260.44 224.905,260.44 224.905,254.447 262.928,254.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#212121"
    },
    points: "264.291,275.419 224.905,275.419 224.905,269.428 263.895,269.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#212121"
    },
    points: "247.604,192.122 235.936,254.447 235.369,257.442 230.781,256.065 231.088,254.447  244.494,190.931  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F57F17"
    },
    d: "M188.247,245.089c10.942-5.435,13.294-23.411,8.276-48.364c-0.153-0.761-0.308-1.5-0.46-2.252 l15.513-5.937l13.329,35.95v62.92c0,4.959-3.16,8.987-7.056,8.987l-25.866-2.997c-3.896,0-7.053-4.025-7.053-8.989l2.462-37.684 C187.559,245.816,187.107,245.652,188.247,245.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E26910"
    },
    d: "M211.576,188.535l-0.935,0.358l12.567,33.896v62.921c0,4.957-3.16,8.986-7.056,8.986 l-25.866-2.997c-1.266,0-2.436-0.459-3.464-1.202c1.288,1.772,3.115,2.898,5.16,2.898l25.866,2.997 c3.896,0,7.056-4.028,7.056-8.987v-62.92L211.576,188.535z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#212121"
    },
    points: "186.506,260.44 224.905,260.44 224.905,254.447 186.882,254.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#212121"
    },
    points: "185.519,275.419 224.905,275.419 224.905,269.428 185.917,269.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#212121"
    },
    points: "202.274,192.094 213.877,254.447 214.439,257.442 219.026,256.065 218.722,254.447  205.317,190.931  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M226.08,285.908c0,0.827-0.524,1.497-1.174,1.497l0,0c-0.65,0-1.177-0.67-1.177-1.497v-59.922 c0-0.827,0.527-1.499,1.177-1.499l0,0c0.649,0,1.174,0.672,1.174,1.499V285.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.08,227.482h-2.353l-2.35,8.988l1.174,2.996h4.705l1.176-2.996L226.08,227.482z  M224.904,238.083c-1.018,0-1.842-0.823-1.842-1.841c0-1.018,0.824-1.842,1.842-1.842c1.017,0,1.842,0.824,1.842,1.842 C226.746,237.26,225.921,238.083,224.904,238.083z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB74D"
    },
    d: "M237.561,189.772c-1.85,3.866-6.799,6.632-12.655,6.632c-5.858,0-10.807-2.766-12.657-6.632 c0.303-2.564,0.639-5.397,1.042-8.396c2.324-2.966,6.633-4.965,11.615-4.965c4.983,0,9.29,1.999,11.614,4.965 C236.924,184.375,237.26,187.208,237.561,189.772z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M246.566,159.576c0,16.106-9.699,34.311-21.661,34.311c-11.966,0-21.664-18.205-21.664-34.311 c0-16.107,9.698-24.017,21.664-24.017C236.867,135.559,246.566,143.468,246.566,159.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M247.01,165.645c-0.525,4.088,0.477,7.555-1.773,7.316c-2.246-0.238-3.645-3.75-3.119-7.839 c0.527-4.088,2.781-7.209,5.031-6.971C249.4,158.393,247.539,161.553,247.01,165.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M202.8,165.645c0.525,4.088-0.481,7.555,1.773,7.316c2.248-0.238,3.647-3.75,3.119-7.839 c-0.528-4.088-2.781-7.209-5.031-6.971C200.408,158.393,202.271,161.553,202.8,165.645z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M237.133,180.071c0,6.752-5.473,11.246-12.228,11.246c-6.754,0-12.229-4.494-12.229-11.246 c0-4.142,2.762-8.463,6.026-11.184c2.058-1.713,2.936-4.163,6.202-4.163c3.356,0,4.147,2.452,6.208,4.166 C234.373,171.611,237.133,175.931,237.133,180.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M216.571,173.058c-0.199,0-0.4-0.071-0.561-0.216l-13.323-12.078 c-0.341-0.309-0.366-0.834-0.057-1.176c0.306-0.339,0.836-0.366,1.177-0.056l13.323,12.075c0.341,0.309,0.366,0.837,0.058,1.176 C217.023,172.965,216.797,173.058,216.571,173.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M233.236,173.058c-0.219,0-0.445-0.089-0.607-0.265c-0.311-0.335-0.299-0.862,0.039-1.178 l12.906-12.076c0.338-0.316,0.865-0.297,1.178,0.039c0.318,0.337,0.299,0.863-0.039,1.178l-12.906,12.077 C233.645,172.983,233.443,173.058,233.236,173.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M214.907,186.388c-0.214,0-0.427-0.081-0.589-0.244l-8.334-8.333 c-0.327-0.327-0.327-0.852-0.002-1.178c0.325-0.329,0.854-0.327,1.178-0.001l8.336,8.333c0.325,0.327,0.325,0.853,0.001,1.178 C215.334,186.307,215.12,186.388,214.907,186.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M234.9,186.388c-0.211,0-0.422-0.081-0.584-0.244c-0.328-0.327-0.328-0.853,0-1.18l8.328-8.333 c0.33-0.326,0.854-0.326,1.178,0c0.326,0.327,0.326,0.852,0,1.179l-8.328,8.333C235.33,186.307,235.115,186.388,234.9,186.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575"
    },
    d: "M231.568,173.054c0,0.46-0.318,0.835-0.832,0.835c-0.834,0-4.166-3.336-5.831-3.334 c-1.667,0-5.001,3.334-5.834,3.334c-0.461,0-0.832-0.375-0.832-0.835l0,0c0-0.46,0.296-0.833,0.832-0.833 c0.833,0,2.5-3.332,5.834-3.333c3.331,0,4.997,3.333,5.831,3.333C231.197,172.221,231.568,172.594,231.568,173.054 L231.568,173.054z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD"
    },
    d: "M229.721,178.897c0,0.309-0.205,0.568-0.455,0.576c-2.902,0.087-5.819,0.087-8.722,0 c-0.252-0.008-0.454-0.268-0.454-0.576l0,0c0-0.31,0.205-0.561,0.457-0.562c2.905,0,5.811,0,8.717,0 C229.516,178.336,229.719,178.587,229.721,178.897L229.721,178.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD"
    },
    d: "M230.672,182.261c0,0.3-0.24,0.584-0.539,0.629c-3.453,0.511-7.004,0.511-10.457,0 c-0.297-0.045-0.539-0.33-0.539-0.629l0,0c0-0.3,0.243-0.513,0.541-0.48c3.46,0.387,6.994,0.386,10.453,0 C230.432,181.749,230.672,181.961,230.672,182.261L230.672,182.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD"
    },
    d: "M230.174,185.771c0,0.305-0.219,0.612-0.49,0.677c-3.143,0.748-6.415,0.747-9.558,0 c-0.271-0.065-0.49-0.372-0.49-0.677l0,0c0-0.305,0.221-0.502,0.492-0.448c3.147,0.644,6.407,0.644,9.554,0 C229.953,185.269,230.174,185.467,230.174,185.771L230.174,185.771z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M243.238,163.925c0,13.946-15.002,4.648-18.335,4.648c-3.334,0-18.332,9.261-18.332-4.684 c0-10,0-8.333,18.332-8.333C243.238,155.556,243.238,153.89,243.238,163.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M246.568,156.795c0,1.155-0.746,2.095-1.664,2.095h-39.995c-0.92,0-1.668-0.939-1.668-2.095l0,0 c0-1.158,0.748-2.097,1.668-2.097h39.995C245.822,154.698,246.568,155.637,246.568,156.795L246.568,156.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M243.238,163.89c0.918,0,1.666-3.729,1.666-8.333h-3.336 C241.568,160.161,242.313,163.89,243.238,163.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M206.571,163.89c0.923,0,1.672-3.729,1.672-8.333h-3.336 C204.907,160.161,205.652,163.89,206.571,163.89z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M223.653,162.221v-3.333l-0.416-0.833c-2.633,0-3.222-0.032-5.158-0.062 c-1.427-0.022-2.676-0.042-3.771-0.042c-3.854,0-4.686,0.314-4.839,0.498c-0.397,0.48-0.397,3.116-0.397,5.441 c0,2.089,0.387,3.6,1.123,4.37c0.195,0.207,0.787,0.83,2.565,0.83c2.334,0,5.267-1.024,7.621-1.845 c1.945-0.68,2.439-1.17,2.439-1.17L223.653,162.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90CAF9"
    },
    d: "M216.362,165.093c-1.034,0-1.87-0.704-1.87-1.573c0-0.869,0.836-1.573,1.87-1.573 c1.033,0,1.872,0.704,1.872,1.573C218.234,164.389,217.395,165.093,216.362,165.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M240.336,158.454c-0.154-0.188-0.99-0.501-4.855-0.501c-1.094,0-2.342,0.019-3.771,0.041 c-1.932,0.03-2.516,0.062-5.139,0.062l-0.416,0.833v3.333l0.832,3.853c0,0,0.5,0.493,2.453,1.178 c2.357,0.827,5.291,1.857,7.627,1.857c1.461,0,3.668,0,3.668-5.188C240.734,161.468,240.734,158.936,240.336,158.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90CAF9"
    },
    d: "M233.443,165.104c-1.033,0-1.869-0.704-1.869-1.573c0-0.869,0.836-1.573,1.869-1.573 c1.035,0,1.871,0.704,1.871,1.573C235.314,164.399,234.479,165.104,233.443,165.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M224.905,132.228c12.179,0,22.054,11.191,22.054,24.997h2.943 c0-15.647-11.193-28.331-24.997-28.331c-13.808,0-24.998,12.684-24.998,28.331h2.941 C202.848,143.419,212.723,132.228,224.905,132.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M205.27,171.777c0.061,1.083-0.769,2.016-1.855,2.08l0,0c-1.085,0.061-2.018-0.769-2.079-1.854 l-1.016-17.697c-0.062-1.087,0.768-2.019,1.854-2.081l0,0c1.087-0.061,2.017,0.77,2.081,1.854L205.27,171.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M201.338,172.003c-3.26,0.186-6.128-3.622-6.406-8.509c-0.282-4.889,2.134-9.002,5.391-9.188 L201.338,172.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#212121"
    },
    d: "M198.494,171.098c1.391-2.85,2.189-10.314,2.001-13.808l0.849,14.707 C200.343,172.048,199.358,171.726,198.494,171.098z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M244.539,171.777c-0.063,1.083,0.768,2.016,1.854,2.08l0,0c1.084,0.061,2.018-0.769,2.082-1.854 l1.01-17.697c0.066-1.087-0.764-2.019-1.85-2.081l0,0c-1.084-0.061-2.016,0.77-2.08,1.854L244.539,171.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8F00"
    },
    d: "M248.471,172.003c3.26,0.186,6.125-3.622,6.408-8.509c0.281-4.889-2.133-9.002-5.395-9.188 L248.471,172.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#212121"
    },
    d: "M254.895,162.599c0,0.288,0,0.594-0.016,0.899c-0.289,4.885-3.156,8.685-6.414,8.498 l0.117-1.968C252.482,169.757,254.133,164.805,254.895,162.599z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F57F17"
    },
    d: "M246.701,152.083c-1.018,0-8.006,2.222-21.796,2.222c-13.791,0-20.78-2.222-21.814-2.222 c-4.462,0-6.667-0.814-1.866-4.801c1.307-6.055,4.224-10.907,8.398-14.232c-0.441-0.831-0.17-1.866,0.661-2.324l3.02-1.764 c0.831-0.475,1.899-0.186,2.391,0.645l0.018,0.051c0.034-0.017,0.068-0.017,0.103-0.034c1.746-0.645,3.612-1.086,5.597-1.323 v-0.22c0-0.085,0-0.153,0.017-0.238c0.119-0.848,0.849-1.51,1.73-1.51h3.494c0.965,0,1.746,0.78,1.746,1.748v0.22 c0.018,0,0.051,0,0.068,0.017c2.002,0.238,3.867,0.678,5.631,1.34l0.018-0.051c0-0.017,0.018-0.017,0.035-0.034 c0.475-0.814,1.543-1.086,2.357-0.611l3.02,1.764c0.832,0.458,1.102,1.493,0.66,2.324c4.174,3.325,7.092,8.177,8.396,14.232 C253.385,151.268,251.182,152.083,246.701,152.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E26910"
    },
    d: "M234.15,129.573l-0.934,8.804c-0.154,1.594-1.578,2.748-3.172,2.578 c-1.477-0.152-2.58-1.408-2.58-2.867c0-0.102,0-0.204,0.018-0.306l0.984-9.465c2.002,0.238,3.867,0.678,5.631,1.34l0.018-0.051 C234.115,129.589,234.133,129.589,234.15,129.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E26910"
    },
    d: "M222.479,137.782c0.017,0.102,0.017,0.187,0.017,0.289c0,1.46-1.102,2.731-2.596,2.884 c-1.594,0.17-3.019-0.984-3.171-2.578l-0.916-8.753c1.746-0.645,3.612-1.086,5.597-1.323L222.479,137.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E26910"
    },
    d: "M248.584,147.282c-15.926,4.461-19.762,3.155-23.679,3.155c4.817-1.255,23.526-0.78,20.235-11.806 C246.719,141.141,247.889,144.042,248.584,147.282z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDEDE"
    },
    d: "M271.027,413.717c-0.01-0.14,0.035-0.338,0.15-0.564c0.207-0.416,0.377-1.438,0.377-2.27 c0-0.834-0.344-1.855-0.756-2.272c-0.416-0.417-1.406-0.974-2.193-1.237l-1.672-0.557c-0.791-0.264-2.109-0.592-2.93-0.726 l-6.102-1.019c-0.822-0.136-1.975-0.73-2.566-1.317l-2.4-2.402c-0.588-0.591-0.984-1.751-0.881-2.575l1.141-9.113 c0.102-0.826,0.246-2.18,0.324-3.01l0.891-9.85h-21.752l0.895,9.85c0.078,0.83,0.25,2.184,0.389,3.004l1.018,6.099 c0.137,0.82,0.248,2.174,0.248,3.007c0,0.833-0.215,2.16-0.482,2.954l-0.553,1.666c-0.268,0.794-0.48,2.122-0.48,2.955v3.026 c0,0.832,0,1.857,0,2.274c0,0.416,0.172,1.097,0.379,1.513c0.125,0.249,0.166,0.459,0.141,0.599 C239.494,412.874,258.646,414.352,271.027,413.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#212121"
    },
    d: "M270.799,408.611c-0.416-0.417-1.406-0.974-2.193-1.237l-1.672-0.557 c-0.791-0.264-2.109-0.592-2.93-0.726l-6.102-1.019c-0.822-0.136-1.975-0.73-2.566-1.317l-2.4-2.402 c-0.588-0.591-0.984-1.751-0.881-2.575l1.141-9.113c0.102-0.826,0.246-2.18,0.324-3.01l0.891-9.85h-1.695l-0.891,9.85 c-0.078,0.83-0.225,2.184-0.326,3.01l-1.139,9.113c-0.105,0.824,0.293,1.984,0.879,2.575l2.4,2.402 c0.594,0.587,1.744,1.182,2.568,1.317l6.102,1.019c0.818,0.134,2.137,0.462,2.928,0.726l1.674,0.557 c0.787,0.264,1.777,0.82,2.193,1.237c0.412,0.416,0.754,1.438,0.754,2.272c0,0.833-0.17,1.854-0.377,2.27 c-0.115,0.226-0.158,0.424-0.148,0.564c-2.092,0.107-4.385,0.15-6.762,0.159c2.988,0.01,5.873-0.026,8.457-0.159 c-0.01-0.14,0.035-0.338,0.15-0.564c0.207-0.416,0.377-1.438,0.377-2.27C271.555,410.049,271.211,409.027,270.799,408.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M271.178,413.743c-0.096,0-0.143-0.078-0.15-0.195c-12.381,0.635-31.533-0.844-36.816,0.035 c-0.016,0.094-0.057,0.16-0.141,0.16c-0.207,0-0.379,0.51-0.379,1.135s0.084,1.306,0.189,1.518 c0.102,0.207,0.871,0.376,1.703,0.376h7.195c0.832,0,1.512-0.342,1.512-0.757c0-0.414,0.684-0.759,1.518-0.759h1.512 c0.834,0,1.859,0.345,2.271,0.759c0.418,0.415,1.441,0.757,2.275,0.757h17.416c0.832,0,1.686-0.169,1.895-0.376 c0.207-0.209,0.377-0.893,0.377-1.518S271.385,413.743,271.178,413.743z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDEDE"
    },
    d: "M178.782,413.717c0.01-0.14-0.035-0.338-0.149-0.564c-0.207-0.416-0.378-1.438-0.378-2.27 c0-0.834,0.344-1.855,0.756-2.272c0.416-0.417,1.406-0.974,2.193-1.237l1.673-0.557c0.79-0.264,2.108-0.592,2.929-0.726 l6.102-1.019c0.823-0.136,1.975-0.73,2.567-1.317l2.4-2.402c0.586-0.591,0.983-1.751,0.879-2.575l-1.14-9.113 c-0.101-0.826-0.246-2.18-0.324-3.01l-0.892-9.85h21.752l-0.895,9.85c-0.077,0.83-0.25,2.184-0.388,3.004l-1.019,6.099 c-0.136,0.82-0.247,2.174-0.247,3.007c0,0.833,0.216,2.16,0.483,2.954l0.554,1.666c0.267,0.794,0.48,2.122,0.48,2.955v3.026 c0,0.832,0,1.857,0,2.274c0,0.416-0.173,1.097-0.38,1.513c-0.124,0.249-0.165,0.459-0.141,0.599 C210.315,412.874,191.163,414.352,178.782,413.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#212121"
    },
    d: "M215.868,389.659c0.138-0.82,0.311-2.174,0.388-3.004l0.895-9.85h-1.696l-0.895,9.85 c-0.077,0.83-0.25,2.184-0.388,3.004l-1.019,6.099c-0.136,0.82-0.247,2.174-0.247,3.007c0,0.833,0.216,2.16,0.482,2.954 l0.554,1.666c0.267,0.794,0.48,2.122,0.48,2.955v5.301c0,0.416-0.173,1.097-0.38,1.513c-0.083,0.166-0.116,0.305-0.131,0.426 c0.645,0.045,1.232,0.098,1.686,0.173c-0.024-0.14,0.017-0.35,0.141-0.599c0.207-0.416,0.38-1.097,0.38-1.513v-5.301 c0-0.833-0.214-2.161-0.48-2.955l-0.554-1.666c-0.267-0.794-0.483-2.121-0.483-2.954c0-0.833,0.111-2.186,0.247-3.007 L215.868,389.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M178.633,413.743c0.095,0,0.141-0.078,0.149-0.195c12.381,0.635,31.533-0.844,36.816,0.035 c0.015,0.094,0.057,0.16,0.141,0.16c0.207,0,0.38,0.51,0.38,1.135s-0.085,1.306-0.19,1.518c-0.102,0.207-0.87,0.376-1.703,0.376 h-7.194c-0.834,0-1.513-0.342-1.513-0.757c0-0.414-0.685-0.759-1.518-0.759h-1.513c-0.833,0-1.858,0.345-2.271,0.759 c-0.418,0.415-1.441,0.757-2.274,0.757h-17.417c-0.832,0-1.685-0.169-1.894-0.376c-0.207-0.209-0.378-0.893-0.378-1.518 S178.426,413.743,178.633,413.743z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerHealth);
export default __webpack_public_path__ + "static/media/worker_health.671722079be526aba27a76888e9b5bc9.svg";
export { ForwardRef as ReactComponent };